import React from 'react';

import Modal from '../base/Modal'; // Adjust path to your base Modal component
import ChatUI from './ChatUI';

const ChatModal = ({ isOpen, onClose, nodeLabel, ...chatUIProps }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      title={`Conversation for: ${nodeLabel}`}
      desc="View the agent's conversation history and send new prompts."
      isOpen={isOpen}
      onClose={onClose}
    >
      {/* The ChatUI component will be the body of this modal */}
      <div className="p-1 pt-4">
        <ChatUI {...chatUIProps} />
      </div>
    </Modal>
  );
};

export default ChatModal;
